import { api, unwrapEnvelope } from "@/lib/api";

/**
 * Map GET /analyze/product payload → Storefront Hunter buy-box / seller fields.
 * Same Oxylabs PDP path Product Analyzer uses — not Buy Sources / 4SGM.
 */
export function mapProductMarketFields(payload) {
  const data = unwrapEnvelope(payload) || {};
  const product = data.product || data;
  const competition = product?.competition || {};
  const walmart = product?.walmart || {};

  const priceRaw =
    walmart.price ??
    product?.source?.price ??
    product?.calc_input?.sale_price ??
    null;
  const price =
    priceRaw == null || priceRaw === ""
      ? null
      : Number(priceRaw);
  const priceOk = price != null && Number.isFinite(price);

  const seller =
    competition.buy_box_owner ||
    competition.sold_and_shipped_by ||
    null;

  const countRaw =
    competition.seller_count ??
    competition.total_offers ??
    competition.observed_offer_count ??
    null;
  const count =
    countRaw == null || countRaw === ""
      ? null
      : Number(countRaw);
  const countOk = count != null && Number.isFinite(count);

  const checkedAt = new Date().toISOString();

  return {
    buyBox: priceOk
      ? {
          status: "success",
          price,
          seller: seller ? String(seller) : null,
          checkedAt,
        }
      : {
          status: "empty",
          price: null,
          seller: null,
          checkedAt,
        },
    sellers: countOk
      ? {
          status: count === 0 ? "empty" : "success",
          count,
          checkedAt,
        }
      : {
          status: "empty",
          count: null,
          checkedAt,
        },
    raw: product,
  };
}

/** In-memory PDP cache so Check Buy Box / Check Sellers share one lookup per item. */
const pdpCache = new Map();

export function clearMarketCheckCache() {
  pdpCache.clear();
}

export async function fetchProductMarket(itemId) {
  const id = String(itemId || "").trim();
  if (!id) throw new Error("Walmart item ID required");
  if (pdpCache.has(id)) return mapProductMarketFields(pdpCache.get(id));
  const res = await api.product({ itemId: id });
  pdpCache.set(id, res);
  return mapProductMarketFields(res);
}

export function emptyMarketCheckEntry() {
  return {
    buyBox: { status: "idle", price: null, seller: null, checkedAt: null },
    sellers: { status: "idle", count: null, checkedAt: null },
  };
}
